import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ProgressTimeService } from "@shared/services/progress-time.service";
import { Config } from "src/app/config";

@Component({
    selector: 'scai-circle-progress',
    templateUrl: './scai-circle-progress.component.html',
    styleUrls: ['./scai-circle-progress.component.scss'],
    standalone: false
})
export class ScaiCircleProgressComponent implements OnChanges {

    @Input() percent: number;

    @Input() estimatedTime: number;

    completedPct: number = undefined;
    displayCompletedPct: number = 0;
    minutesLeft: string = null;
    secondsLeft: string = null;
    showProgressBarAndTimeLeft: boolean = Config.assetConfigData['showEstimatedTimeLeftDuringDocProcessing'];

    constructor(private progressTimeService: ProgressTimeService) {}
    
  ngOnChanges(changes: SimpleChanges): void {

    let percent = changes['percent'];

    if (percent != null) {
      let percentValue = percent.currentValue;

      if (this.completedPct == undefined || this.completedPct < percentValue) {
        this.completedPct = percentValue;
        this.displayCompletedPct = Math.round(this.completedPct);
      }
    }
 
    if (this.showProgressBarAndTimeLeft) {
      
      let estimatedTime = changes['estimatedTime'];
      if (estimatedTime != null) {
        
        this.extractTime(this.progressTimeService.getTimeInMinutes(estimatedTime.currentValue));
      }
    }
  }

    private extractTime(time: string): void {
      if (time == undefined) {
        return;
      }
      const timeParts = time.split(':');
      this.minutesLeft = timeParts[0];
      this.secondsLeft = timeParts[1];

    }

}